import { logger } from 'services';

interface TaskClick {
  (data: string): void;
}

export type ToolbarPositions = {
  top: number | undefined;
  left: number | undefined;
};
interface RenderForm {
  (positions: ToolbarPositions): void;
}

export interface ContentTaskIdMap {
  [key: number]: {
    content: string;
    isActive: boolean;
  };
}
export const TaskService = {
  state: {
    sendDataFn: (data: string): void => logger.log(data),
    renderFormFn: (positions: ToolbarPositions): void =>
      logger.log('renderFormFn', positions),
    contentIdMap: {},
    activeSelectionEl: null,
  },

  initSubscriber: (
    onTaskClickCallback: TaskClick,
    renderFormCallback: RenderForm,
  ): void => {
    TaskService.state.sendDataFn = onTaskClickCallback;
    TaskService.state.renderFormFn = renderFormCallback;
  },
  sendData: (data: string): void => {
    TaskService.state.sendDataFn(data);
  },
  showTaskForm: (positions: ToolbarPositions): void => {
    TaskService.state.renderFormFn(positions);
  },
};
